import { text_colorTextSecondary } from 'ext-ui/style/colors'
import React, { SVGProps } from 'react'

const SvgSidenavHelpCenterInactive = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      fill={props.fill || text_colorTextSecondary}
      fillRule="evenodd"
      d="M4.083 10a6.75 6.75 0 1 1 3.75 6.049l-.256-.128-.277.077-4.227 1.168 1.714-3.503.162-.332L4.785 13a6.72 6.72 0 0 1-.702-3Zm6.75-8.25a8.25 8.25 0 0 0-7.552 11.576L1.4 17.172c-.442.904.39 1.906 1.359 1.637l4.672-1.291A8.25 8.25 0 1 0 10.834 1.75Zm-.188 4.556c-1.354 0-1.975.802-1.975 1.343 0 .391.33.572.601.572.228 0 .321-.137.429-.296.147-.217.323-.476.914-.476.502 0 .902.22.902.682 0 .443-.375.731-.693.975-.07.054-.139.106-.199.157-.29.25-.671.662-.671 1.524 0 .521.14.671.551.671.491 0 .591-.22.591-.41 0-.522.01-.822.562-1.253.27-.21 1.123-.893 1.123-1.835s-.852-1.654-2.135-1.654Zm-.131 5.844a.77.77 0 0 0-.762.772c0 .41.331.772.762.772s.772-.361.772-.772a.779.779 0 0 0-.772-.772Z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgSidenavHelpCenterInactive
